import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  ModalProps,
  Stack,
  Typography,
} from '@mui/material';
import {
  Close as CloseIcon,
  ContentCopy as ContentCopyIcon,
  Warning as WarningIcon,
} from '@mui/icons-material';

type AppTokenSecretModalProps = {
  open: boolean;
  onClose: () => void;
  newTokenSecret: string;
};

export const AppTokenSecretModal: FC<AppTokenSecretModalProps> = (props) => {
  const { open, onClose, newTokenSecret } = props;
  const { t } = useTranslation();

  // close handlers
  const closeHandlerWithPrevent: ModalProps['onClose'] = (_, reason) => {
    if (reason === 'backdropClick') return;
    onClose();
  };
  const closeHandler = () => {
    onClose();
  };

  // copy handler
  const copySecretKey = () => {
    void navigator.clipboard.writeText(newTokenSecret);
  };

  return (
    <Dialog
      open={open}
      onClose={(_, reason) => closeHandlerWithPrevent(_, reason)}
      PaperProps={{ sx: { minWidth: '380px' } }}
    >
      <DialogTitle>{t('app-tokens.modals.token-secret.title')}</DialogTitle>
      <IconButton
        aria-label="close"
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
        onClick={() => closeHandler()}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent>
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          gap={1}
          sx={{ marginBottom: 3 }}
        >
          <Typography variant="h6">{newTokenSecret}</Typography>
          <IconButton aria-label="copy" color="info" onClick={() => copySecretKey()}>
            <ContentCopyIcon />
          </IconButton>
        </Stack>

        <Stack direction="row" alignItems="center" gap={2}>
          <WarningIcon color="warning" />
          {t('app-tokens.modals.token-secret.text')}
        </Stack>
      </DialogContent>

      <DialogActions />
    </Dialog>
  );
};
